import { Preferences } from "../../profile/objects/preferences";
import { Column } from "../objects/column";
import { ListPreferenceResult, setListPreference } from "../../utils/list/utils/setListPreference";
import { SALES_THIRD_PARTY_MODULE, THIRD_PARTY_COLUMN } from "../constant/salesReceiptConstant";

export const setThirdPartyPreference = (new_preferences: Preferences[], state_columns: Column[]): ListPreferenceResult =>
    setListPreference(new_preferences, state_columns, {
        module: SALES_THIRD_PARTY_MODULE,
        default_columns: THIRD_PARTY_COLUMN,
        default_order_by: '',
        default_order: 'asc',
    });
